<template>
    <div>
        <input type="hidden" :name="name" :id="id" v-model="selectedValue">
        <vue-multiselect
            v-model="selectedOption"
            :options="options"
            :placeholder="placeholder"
            :customLabel="customLabel"
            @select="onSelect"
        >
        </vue-multiselect>
    </div>
</template>

<script>
export default {
    model:{
        prop: 'value',
        event: 'change',
    },
    props:{
        name: String,
        id: String,
        value: String|Number,
        options: {
            type: Array,
            default: []
        },
        placeholder: {
            type: String,
            default: 'Selecione uma opção'
        },
        onSelect: {
            type: Function,
            default: ()=>{}
        }
    },
    data(){
        return {
            selectedOption: this.options.find(option=>option.value==this.value),
            selectedValue: this.value,
        }
    },
    updated(){
        this.selectedOption = this.options.find(option=>option.value==this.value);
    },
    watch:{
        selectedOption: function (newOption, oldOption){
            if(newOption){
                this.selectedValue = newOption.value;
                this.$emit('change', newOption.value);
            }
        },
    },
    methods: {
        customLabel(option){
            return option.text
        }
    }
}
</script>